var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeposit1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-ca_rd",
    "data-name": "icon-ca rd",
    transform: "translate(0 -3397)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    width: 56,
    height: 56,
    transform: "translate(0 3397)",
    fill: "#02fdb1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fi-rr-file-invoice-dollar",
    transform: "translate(-8.679 3409)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67443",
    "data-name": "Group 67443",
    transform: "translate(21.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67442",
    "data-name": "Group 67442",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80501",
    "data-name": "Path 80501",
    d: "M41.333,30.667A1.333,1.333,0,0,1,40,32H28a6.674,6.674,0,0,1-6.667-6.667V6.667A6.674,6.674,0,0,1,28,0h6.02a9.277,9.277,0,0,1,6.6,2.733l4.645,4.648a9.383,9.383,0,0,1,1,1.177,1.333,1.333,0,0,1-2.169,1.549,6.638,6.638,0,0,0-.712-.84L38.735,4.62a6.681,6.681,0,0,0-1.4-1.073V9.333a1.335,1.335,0,0,0,1.333,1.333h4a1.333,1.333,0,0,1,0,2.667h-4a4,4,0,0,1-4-4V2.7q-.322-.03-.647-.031H28a4,4,0,0,0-4,4V25.333a4,4,0,0,0,4,4H40A1.333,1.333,0,0,1,41.333,30.667Zm7.58-8.977-4.055-.676A1.024,1.024,0,0,1,44,20a1.335,1.335,0,0,1,1.333-1.333h3.024a1.342,1.342,0,0,1,1.156.667A1.333,1.333,0,1,0,51.82,18a4.012,4.012,0,0,0-3.464-2H48V14.665a1.333,1.333,0,0,0-2.667,0V16a4,4,0,0,0-4,4,3.682,3.682,0,0,0,3.087,3.644l4.055.676a1.024,1.024,0,0,1,.859,1.013A1.335,1.335,0,0,1,48,26.665H44.975A1.342,1.342,0,0,1,43.819,26a1.332,1.332,0,1,0-2.307,1.335,4.011,4.011,0,0,0,3.464,2h.357v1.333a1.333,1.333,0,1,0,2.667,0V29.332a4,4,0,0,0,4-4,3.682,3.682,0,0,0-3.087-3.644ZM30,20h7.333a1.333,1.333,0,1,0,0-2.667H30a3.337,3.337,0,0,0-3.333,3.333v2.667A3.338,3.338,0,0,0,30,26.667h7.333a1.333,1.333,0,1,0,0-2.667H30a.667.667,0,0,1-.667-.667V20.667A.667.667,0,0,1,30,20Zm-2-5.333h2.667a1.333,1.333,0,1,0,0-2.667H28a1.333,1.333,0,1,0,0,2.667Zm0-5.333h2.667a1.333,1.333,0,1,0,0-2.667H28a1.333,1.333,0,1,0,0,2.667Z",
    transform: "translate(-21.333)",
    fill: "#12784a"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeposit1);
export default __webpack_public_path__ + "static/media/deposit1.fddd786e316223f276bcb63747214810.svg";
export { ForwardRef as ReactComponent };